/**
 * Activity Service
 *
 * Fetches a peer's last_active_at timestamp for the activity time ladder on
 * chat headers and detail pages — through the checked peer read (open-access
 * lockdown): only for someone the caller is connected to.
 */

import { getPeerProfiles } from './people/peerProfiles';

/**
 * Fetch last_active_at for a single peer (chat page, detail page).
 * The peer's profile can be absent (deleted account, device-local connection
 * not present in this backend) — no stamp, no error.
 *
 * @param {string} profileUserId - Peer's profile_user_id
 * @returns {Promise<string|null>} ISO timestamp or null
 */
export const getPeerActivity = async (profileUserId) => {
  if (!profileUserId) return null;
  const { rows } = await getPeerProfiles([profileUserId]);
  return rows.get(profileUserId)?.lastActiveAt || null;
};
